import { useQuery } from "react-query";
import axios from "infra/http";
import { AreaComumBloqueioDataItem } from "../typings";

function useBloqueioDatasAreaComum(tenantId: string, areaComumId: string) {
  return useQuery(
    `/v1/tenants/${tenantId}/area-comum/${areaComumId}/bloqueio-data`,
    async () => {
      const { data } = await axios.get<AreaComumBloqueioDataItem[]>(
        `/v1/tenants/${tenantId}/area-comum/${areaComumId}/bloqueio-data`
      );

      return data;
    },
    {
      enabled: !!areaComumId && !!tenantId,
    }
  );
}

export default useBloqueioDatasAreaComum;
